import { isObject } from './isObject';
import { isString } from './isString';

type Property<T, Args extends any[], R> = (this: T, ...args: Args) => R;

type IsFunction = {
   (value: unknown): value is (...args: any[]) => any;
   <T, Args extends any[], R>(obj: T, methodName: keyof T): obj is T &
      { [K in keyof T]: T[K] extends Property<T, Args, R> ? Property<T, Args, R> : never };
};

export const isFunction: IsFunction = ((arg1, arg2) => {
   if (isObject(arg1) && isString(arg2)) {
      const obj = arg1;
      const methodName = arg2;
      const method = obj[methodName];
      return typeof method === 'function';
   }

   return typeof arg1 === 'function';
}) as IsFunction;
